import { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { Box, Alert } from '@mui/material';
import InfoIcon from "@mui/icons-material/Info";

const BarChart = ({ name, option, dataLength }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    if (dataLength <= 0) return;

    if (!chartInstanceRef.current) {
      chartInstanceRef.current = echarts.init(chartRef.current);
    }

    const chart = chartInstanceRef.current;
    chart.setOption(option);

    const resizeObserver = new ResizeObserver(() => {
      setTimeout(() => {
        chart.resize();
      }, 0);
    });

    resizeObserver.observe(chartRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [option, dataLength]);

  return (
    <Box sx={{ position: 'relative' }}>
      {dataLength > 0 ? (
        <Box ref={chartRef} sx={{ height: '400px' }} />
      ) : (
        <Alert icon={<InfoIcon fontSize="inherit" />} severity="info">
          No data available for {name}.
        </Alert>
      )}
    </Box>
  );
};

export default BarChart;
